//@ts-nocheck
import React, { useEffect, useRef } from "react";
import { animate, useInView } from "framer-motion";
import { Card } from './Card';

interface StatProps {
  num: number;
  suffix: string;
  decimals?: number;
  subheading: string;
}

const Stat: React.FC<StatProps> = ({ num, suffix, decimals = 0, subheading }) => {
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (!isInView) return;

    animate(0, num, {
      duration: 2.5,
      onUpdate(value) {
        if (ref.current) {
          ref.current.textContent = value.toFixed(decimals);
        }
      },
    });
  }, [num, decimals, isInView]);

  return (
    <Card className="flex flex-col items-center justify-center p-6">
      <p className="text-4xl font-bold mb-2">
        <span ref={ref}></span>
        {suffix}
      </p>
      <p className="text-sm text-gray-600 text-center">{subheading}</p>
    </Card>
  );
};

export const EmpowermentCountUpStats: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
      <Stat
        num={34.8}
        suffix="M"
        decimals={1}
        subheading="Small businesses in America"
      />
      <Stat
        num={90}
        suffix="M"
        subheading="Jobs created by 2029"
      />
      <Stat
        num={1}
        suffix="T"
        subheading="Economic value unlocked"
      />
    </div>
  );
};
